import { concat } from 'lodash';
import RouterFoodProducts from './router-food-products';
import RouterDishes from './router-dishes';
import RouterMeals from './router-meals';
import RouterDrinks from './router-drinks';

export default concat(RouterFoodProducts, RouterDrinks, RouterDishes, RouterMeals);



// WEBPACK FOOTER //
// ./src/router/professional/stuff-to-eat/index.js